import React, { useState } from 'react';
import ReactEcharts from "echarts-for-react";

/**
 * TopPlatformList component for displaying platforms as a chart with option to show as a list
 * @param {Object} props Component props
 * @param {string} props.title Title of the list
 * @param {Array} props.items Array of platforms in format {name, value}
 * @param {Object} props.chartOption ECharts option object for the platform chart
 */
const TopPlatformList = ({ title, items = [], chartOption }) => {
  const [viewMode, setViewMode] = useState('chart'); // 'chart' or 'list'

  // Safely format the value, handling different data types
  const formatValue = (value) => {
    if (value === undefined || value === null) return '0';
    
    // If value is already a number, format it
    if (typeof value === 'number') {
      return value.toLocaleString();
    }
    
    // If value is a string, try to parse it as a number first
    try {
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        return numValue.toLocaleString();
      }
    } catch (e) {
      // If parsing fails, return the original value
      console.error("Error parsing value:", e);
    }
    
    // Return original value if all else fails
    return value;
  };

  return (
    <div className="dash-card">
      <div className="dash-card-heading mb-3 d-flex justify-content-between align-items-center">
        <h2 className="dash-card-title">{title}</h2>
        <div className="btn-group" role="group">
          <button 
            type="button" 
            className={`btn btn-sm ${viewMode === 'chart' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setViewMode('chart')}
          >
            <i className="fi fi-rr-chart-pie-alt me-1"></i>
            Chart
          </button>
          <button 
            type="button" 
            className={`btn btn-sm ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setViewMode('list')}
          >
            <i className="fi fi-rr-list me-1"></i>
            List
          </button>
        </div>
      </div>
      {items.length > 0 ? (
        viewMode === 'chart' ? (
          <div className="d-flex justify-content-center align-items-center">
            <ReactEcharts option={chartOption} style={{ height: '320px', width: '100%', maxWidth: '600px' }} />
          </div>
        ) : (
          <div className="top-items" style={{ maxHeight: '600px', overflowY: 'auto' }}>
            {items.map((item, i) => (
              <div className="top-item" key={i}>
                <h6>{i + 1}. {item.channel || item.platform || 'Unknown Platform'}</h6>
                <span>${formatValue(item.totalRevenue || item.revenue)}</span>
              </div>
            ))}
          </div>
        )
      ) : (
        <div className="no-data">No Data</div>
      )}
    </div>
  );
};

export default TopPlatformList; 